<template>
    <div class="d-flex align-items-center">
        <div class="custom-checkbox" :class="{ 'checked': value, 'disabled': disabled }" @click="setValue">
            <input type="checkbox" :id="id" :value="value" class="input" />
            <Icon v-if="value" name="check-mark" class="c16" />
        </div>
        <label v-if="label" :for="id" class="text-black neue-roman" :class="{ 'fsp14 pl8': this.isMobile, 'pl12': !this.isMobile }">{{ label }}</label>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'; 
export default {
    name: 'Checkbox',
    components: {
        Icon
    },
    props: {
        id: {
            type: String,
        },
        label: {
            type: String,
        },
        dataValue: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: this.dataValue ? this.dataValue : false,
        }
    },
    watch: {
        dataValue: {
            handler(newValue) {
                console.log(newValue);
                //if(this.nonControl) {
                    this.value = newValue;
                //}
            },
            immediate: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        setValue() {
            if(!this.disabled) {
                //this.value = !this.value;

                this.$emit('updateParentState', {
                    id: this.id,
                    value: !this.value
                })
            }
        },
        test() {
            console.log('test');
        }
    }
}
</script>

<style lang="scss" scoped>
.input {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.custom-checkbox {
    position: relative;
    width: 24px;
    height: 24px;
    border: 2px solid $menu-bg;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;

    &.checked {
        border: none;
        background-color: $menu-bg;

        &.disabled {
            background-color: $primary-grey;
        }
    }

    &.disabled {
        border-color: $primary-grey;
    }
}
</style>